import { createActionGroup } from '@ngrx/store';

import { AccountNavigationBlock } from 'ish-core/models/account-navigation-block/account-navigation-block.model';
import { payload } from 'ish-core/utils/ngrx-creators';

export const accountNavigationBlocksActions = createActionGroup({
  source: 'Account Navigation Blocks',
  events: {
    /** adds a navigation card the user created to their profile */
    'Add Account Navigation Block': payload<{ block: AccountNavigationBlock }>(),
    /** replaces an existing navigation card of the user with the edited one */
    'Update Account Navigation Block': payload<{ block: AccountNavigationBlock }>(),
    /** removes the navigation card with the given id */
    'Remove Account Navigation Block': payload<{ id: string }>(),
    /** takes over the navigation cards of the user profile, the single source of truth */
    'Sync Account Navigation Blocks': payload<{ blocks: AccountNavigationBlock[] }>(),
  },
});
